;(function ($) {

    /* --------------------------------------------
     * --cc plugins
     * -------------------------------------------- */

    /*
     * .addClassSVG(className)
     * Adds the specified class(es) to each of the set of matched SVG elements.
     */
    $.fn.addClassSVG = function(className){
        var $self = $(this);
        $self.attr('class', function(index, existingClassNames) {
            if(existingClassNames && !$self.hasClass(className)){
                return existingClassNames + ' ' + className;    
            }
            return className;
        });
        return this;
    };

    /*
     * .removeClassSVG(className)
     * Removes the specified class to each of the set of matched SVG elements.
     */
    $.fn.removeClassSVG = function(className){
        $(this).attr('class', function(index, existingClassNames) {
            return existingClassNames.replace(className, '');
        });
        return this;
    };

})(jQuery);